<div tid="entity-panel" class="container" loading-spin [isLoading]="isPageLoading" [loadingSize]="'big'">
    <div class="item-header">
        <entity-header [config]="entityConfig" [eventKey]="eventKey" [eventValue]="eventValue">
        </entity-header>
    </div>
    <div class="item-tab-body">
        <div class="panel-tab">
            <tam-tab-set [selectedIndex]="selectedIndex" [draggable]="draggableTab"
                (selectChange)="selectChange($event)">
                <tam-tab *ngFor="let item of menuItems;trackBy:trackByFn" [title]="item.title"
                    [iconName]="item.iconName" [disabled]="item.disabled" [editable]="item.editable"
                    [editing]="item.editing">
                </tam-tab>
            </tam-tab-set>
        </div>
        <div class="panel-info">
            <div class="panel-left panel-left-height-embedded" *ngIf="selectedIndex===0">
                <div tid="contact_body" class="item-body">
                    <entity-body [config]="entityConfig"></entity-body>
                </div>
            </div>
            <div class="panel-right panel-right-height-embedded" *ngIf="selectedIndex===1">
                <div class="item-relationships" tid="entity_relationships" *ngIf="!isRelationshipLoading">
                    <relationship-tree [config]="relationshipTreeConfig" [eventKey]="eventKey"
                        [eventValue]="eventValue"></relationship-tree>
                </div>
            </div>
        </div>
    </div>
</div>